import React from "react";
import Grid from "@material-ui/core/Grid";
import Header from "../Header";
import Companies from "../components/Companies";
import arrow from "../assets/images/arrow.png";
import sessionImage from "../assets/images/sessionImage.png";
import logo from "../assets/images/logo.png";
import headImage from "../assets/images/online-session.png";
import dialogger from "../assets/images/dialogger.png";
import hokkaido from "../assets/images/hokkaidoSinbunsha.jpeg";
import jobdas from "../assets/images/jobdas.png";
import jobcafe from "../assets/images/jobcafe.jpg";
import noMaps from "../assets/images/noMaps.png";
import sapporo from "../assets/images/sapporo.png";
import white from "../assets/images/white.png";
import Head from "../components/Head";
import Twemb from "../Twemb";
import "../index.css";

const session0425 = (props) => {
  return (
    <>
      <Head
        title="北海道初！オンライン合同企業説明会2020"
        body="4月25日にオンラインで合同企業説明会を行います。大手企業など21社参加予定！"
      />
      <img
        src={headImage}
        className="headImage2"
        alt="headerImage"
        onMouseDownCapture={() => {
          return false;
        }}
        onSelectCapture={() => {
          return false;
        }}
      />
      <p style={{ textAlign: "center" }}>参加はこちらから！</p>
      <p className="form">
        <a href="https://bit.ly/3aWuaNL">参加申込フォーム</a>
      </p>

      <div className="container">
        <Header title="オンライン合説のイメージ" name="peach-header" />
        <img
          src={sessionImage}
          className="contents sessionImage"
          alt="sessionImage"
        />

        <Header title="対象" name="peach-header" />
        <p className="contents">
          道内に就職したい大学生・院生・短大生・専門生！　21卒に限りません！
        </p>
        <p className="form">
          <a href="https://bit.ly/3aWuaNL">参加申込フォーム</a>
        </p>

        <Header title="日程" name="peach-header" />
        <p className="contents">
          4月25日（土）
          <br />
          12:00～13:30　開場・準備
          <br />
          13:30～13:50　全体説明
          <br />
          14:00～17:20　企業説明会（20分説明、10分移動、希望企業のみ座談会あり）
          <br />
          18:00　　　　　終了予定
          <br />
          ※途中参加、途中退場も大歓迎！
        </p>
        <Header title="当日のスケジュール" name="peach-header" />
        <table className="tg contents">
          <tbody>
            <tr>
              <th></th>
              <th className="centerTitle1">全体の流れ</th>
              <th className="centerTitle2">ルームA</th>
              <th className="centerTitle2">ルームB</th>
              <th className="centerTitle2">ルームC</th>
              <th className="centerTitle2">ルームD</th>
            </tr>
            <tr>
              <td className="center time">12:00〜13:30</td>
              <td className="center compSession1">OPEN・準備</td>
              <td className="center compSession2" colspan="4">
                OPEN・準備(ルームDで行います)
              </td>
            </tr>
            <tr>
              <td className="center time">13:30〜13:50</td>
              <td className="center compSession1">全体説明</td>
              <td className="center compSession2" colspan="4">
                全体説明(ルームDで行います)
              </td>
            </tr>
            <tr>
              <td className="center break">10分休憩</td>
              <td className="center arrow" colspan="5">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>
            <tr>
              <td className="center time">14:00〜14:20</td>
              <td className="center compSession1">1クール</td>
              <td className="center compSession2">
                北海道コカ・コーラボトリング(メーカー(飲料))
              </td>
              <td className="center compSession2">
                りらいあコミュニケーションズ(各種ビジネスサービス　シンクタンク・マーケティング・調査)
              </td>
              <td className="center compSession2">
                キットアライブ(IT・情報処理 )
              </td>
              <td className="center compSession2" rowSpan="15">
                座談会
              </td>
            </tr>
            <tr>
              <td className="center break">10分休憩</td>
              <td className="center arrow" colSpan="4">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>
            <tr>
              <td className="center time">14:30〜14:50</td>
              <td className="center compSession1">2クール</td>
              <td className="center compSession2">井上技研(建設業)</td>
              <td className="center compSession2">北海道銀行(銀行)</td>
              <td className="center compSession2">SOC(IT・ソフトウェア)</td>
            </tr>
            <tr>
              <td className="center break">10分休憩</td>
              <td className="center arrow" colSpan="4">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>
            <tr>
              <td className="center time">15:00〜15:20</td>
              <td className="center compSession1">3クール</td>
              <td className="center compSession2">
                めもりあるグループホールディングス(冠婚葬祭)
              </td>
              <td className="center compSession2">不二建設(建設)</td>
              <td className="center compSession2">イオン北海道(小売業)</td>
            </tr>
            <tr>
              <td className="center break">10分休憩</td>
              <td className="center arrow" colSpan="4">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>
            <tr>
              <td className="center time">15:30〜15:50</td>
              <td className="center compSession1">4クール</td>
              <td className="center compSession2">
                サッポロドラッグストアー(ドラッグストア)
              </td>
              <td className="center compSession2">日本ニューホランド(商社)</td>
              <td className="center compSession2">
                クオリサイトテクノロジーズ(IT・情報処理)
              </td>
            </tr>
            <tr>
              <td className="center break">10分休憩</td>
              <td className="center arrow" colSpan="4">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>
            <tr>
              <td className="center time">16:00〜16:20</td>
              <td className="center compSession1">5クール</td>
              <td className="center compSession2">
                北海道セキスイハイム(住宅)
              </td>
              <td className="center compSession2">
                サングリン太陽園(農業生産資材卸売業)
              </td>
              <td className="center compSession2">
                クリプトン・フューチャー・メディア(IT・ソフトウェア)
              </td>
            </tr>
            <tr>
              <td className="center break">10分休憩</td>
              <td className="center arrow" colSpan="4">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>
            <tr>
              <td className="center time">16:30〜16:50</td>
              <td className="center compSession1">6クール</td>
              <td className="center compSession2">檜山鐵工所(鉄工業)</td>
              <td className="center compSession2">
                オカモトグループ(サービス、小売)
              </td>
              <td className="center compSession2">学習塾あすなろ会(学習塾)</td>
            </tr>
            <tr>
              <td className="center break">10分休憩</td>
              <td className="center arrow" colSpan="4">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>
            <tr>
              <td className="center time">17:00〜17:20</td>
              <td className="center compSession1">7クール</td>
              <td className="center compSession2">
                オカモト(エクステリア工事業(外構・庭他))
              </td>
              <td className="center compSession2">
                さくらCSホールディングス(医療福祉)
              </td>
              <td className="center compSession2">パナソニックITS(情報通信)</td>
            </tr>
            <tr>
              <td className="center break">10分休憩</td>
              <td className="center arrow" colSpan="4">
                <img src={arrow} alt="arrow"></img>
              </td>
            </tr>
            <tr>
              <td className="center time">17:30〜17:50</td>
              <td className="center compSession1">8クール</td>
              <td className="center compSession2">
                生活協同組合コープさっぽろ(協同組合)
              </td>
              <td className="center compSession2">
                練成会グループ(教育サービス)
              </td>
              <td className="center compSession2">
                ミクロスソフトウエア(ソフトウェア開発)
              </td>
            </tr>
            <tr>
              <td className="center time">17:50〜18:00</td>
              <td className="center compSession1">閉会</td>
              <td className="center compSession2">閉会の挨拶</td>
              <td className="center compSession2">閉会の挨拶</td>
              <td className="center compSession2">閉会の挨拶</td>
              <td className="center compSession2">閉会の挨拶</td>
            </tr>
          </tbody>
        </table>
        <p className="contents">
          当日スケジュールは予定です。参加企業数や運営の都合により変更することがございます。具体的な企業様名は随時更新となります。
        </p>

        <Header title="参加方法・用意するもの" name="peach-header" />
        <p className="form">
          <a href="https://bit.ly/3aWuaNL">参加申込フォーム</a>
        </p>
        <p className="contents">
          ・上のボタンより、参加申込みをお願いいたします。
          <br />
          ・当日使用するスマホ・PCに、「zoom」アプリをインストールしておいてください。
          <br />
          （iPhoneは
          <a href="https://apps.apple.com/us/app/id546505307">コチラ</a>{" "}
          、Androidは
          <a href="https://play.google.com/store/apps/details?id=us.zoom.videomeetings">
            コチラ
          </a>{" "}
          、PCは<a href="https://zoom.us/download#client_4meeting">コチラ</a>
          インストール所要時間5分程度）
          <br />
          ・当日使用するzoomのURL（登録メールアドレスに前日までにお送りいたします）
        </p>

        {/*} <Header title='参加予定企業様(随時更新)' name="peach-header" />
                <Companies
                    data={props.companies} />*/}
        <Header title="主催" name="peach-header" />
        <div className="contents">
          <Grid item xs={6} sm={3}>
            <div style={{ width: "100%", height: "100%" }}>
              <a
                href="https://13labo.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  style={{
                    width: "100%",
                    height: "80px",
                    objectFit: "contain",
                  }}
                  alt="complex"
                  src={logo}
                />
              </a>
              <p className="companyTitle">13LABO(株式会社オガワヤ)</p>
            </div>
          </Grid>

          <Twemb />
        </div>

        <Header title="共催" name="peach-header" />
        <div className="contents">
          <Grid item xs={6} sm={3}>
            <div style={{ width: "100%", height: "100%" }}>
              <a
                href="https://www.dialogger-inc.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  style={{
                    width: "100%",
                    height: "80px",
                    objectFit: "contain",
                  }}
                  alt="complex"
                  src={dialogger}
                />
              </a>
              <p className="companyTitle">合同会社Dialogger</p>
            </div>
          </Grid>
        </div>

        <Header title="協力" name="peach-header" />
        <div className="contents">
          <Grid container spacing={2}>
            <Grid item xs={6} sm={3}>
              <div style={{ width: "100%", height: "100%" }}>
                <a
                  href="http://kk.hokkaido-np.co.jp/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    style={{
                      width: "100%",
                      height: "80px",
                      objectFit: "contain",
                    }}
                    alt="complex"
                    src={hokkaido}
                  />
                </a>
                <p className="companyTitle">北海道新聞社</p>
              </div>
            </Grid>
            <Grid item xs={6} sm={3}>
              <div style={{ width: "100%", height: "100%" }}>
                <a
                  href="https://jobdas.hokkaido-np.co.jp/2021/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    style={{
                      width: "100%",
                      height: "80px",
                      objectFit: "contain",
                    }}
                    alt="complex"
                    src={jobdas}
                  />
                </a>
                <p className="companyTitle">ジョブダス就活</p>
              </div>
            </Grid>
          </Grid>
        </div>

        <Header title="後援" name="peach-header" />
        <div className="contents">
          <Grid container spacing={2}>
            <Grid item xs={6} sm={3}>
              <div style={{ width: "100%", height: "100%" }}>
                <a
                  href="http://www.pref.hokkaido.lg.jp/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    style={{
                      width: "100%",
                      height: "80px",
                      objectFit: "contain",
                    }}
                    alt="complex"
                    src={white}
                  />
                </a>
                <p className="companyTitle">北海道</p>
              </div>
            </Grid>
            <Grid item xs={6} sm={3}>
              <div style={{ width: "100%", height: "100%" }}>
                <a
                  href="https://www.city.sapporo.jp/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    style={{
                      width: "100%",
                      height: "80px",
                      objectFit: "contain",
                    }}
                    alt="complex"
                    src={sapporo}
                  />
                </a>
                <p className="companyTitle">札幌市</p>
              </div>
            </Grid>
            <Grid item xs={6} sm={3}>
              <div style={{ width: "100%", height: "100%" }}>
                <a
                  href="http://www.jobcafe-h.jp/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    style={{
                      width: "100%",
                      height: "80px",
                      objectFit: "contain",
                    }}
                    alt="complex"
                    src={jobcafe}
                  />
                </a>
                <p className="companyTitle">ジョブカフェ北海道</p>
              </div>
            </Grid>
            <Grid item xs={6} sm={3}>
              <div style={{ width: "100%", height: "100%" }}>
                <a
                  href="https://no-maps.jp/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    style={{
                      width: "100%",
                      height: "80px",
                      objectFit: "contain",
                    }}
                    alt="complex"
                    src={noMaps}
                  />
                </a>
                <p className="companyTitle">NoMaps実行委員会</p>
              </div>
            </Grid>
          </Grid>
        </div>

        <Header title="企業様の参加方法" name="peach-header" />
        <p className="contents">
          企業担当者様は<a href="https://bit.ly/3ecnv46">こちら！</a>
        </p>

        <Header title="その他お問い合わせ" name="peach-header" />
        <p className="contents">
          13LABOホームページよりお問い合わせください。
          <a href="https://13labo.com">お問い合わせフォーム</a>
        </p>

        <Header title="Special Thanks!" name="peach-header" />
        <p className="contents">
          idea from<a href="https://twitter.com/jony_fj">ジョニー藤村様</a>
          <br />
          created by <a href="https://twitter.com/tanakarn98">tanaka</a>/
          <a href="https://twitter.com/takapiro_99">takapiro</a>
          <br />
          icon from<a href="https://icons8.com">icons8</a>
        </p>
      </div>
    </>
  );
};

export default session0425;
